// Import the enhanced API service functions
import { 
    startCapture as apiStartCapture,
    stopCapture as apiStopCapture,
    getCaptureStatus as apiGetCaptureStatus,
    getStreakCount,
    getDirections,
    getLatestStreakCount,
    setAmount,
    getLatestAmount
} from './api_services';

/**
 * Start a new capture session
 * @returns {Promise<Object>} - The API response with capture details
 */
export async function start_capture() {
    return apiStartCapture();
}

/**
 * Stop the current capture session
 * @returns {Promise<Object>} - The API response with stop confirmation
 */
export async function stop_capture() {
    return apiStopCapture();
}

/**
 * Get the current capture status
 * @returns {Promise<Object>} - The API response with capture status
 */
export async function get_capture_status() {
    return apiGetCaptureStatus();
}

/**
 * Get streak count for a specific number of directions
 * @param {number} numberOfDirections - Number of directions to get streak count for
 * @returns {Promise<Object>} - The API response with streak count
 */
export { getStreakCount };

/**
 * Get available directions
 * @returns {Promise<Object>} - The API response with directions
 */
export { getDirections };

/**
 * Get the latest streak count
 * @returns {Promise<Object>} - The API response with latest streak count
 */
export { getLatestStreakCount };

/**
 * Set a new amount
 * @param {number} amount - The amount to set
 * @returns {Promise<Object>} - The API response
 */
export { setAmount };

/**
 * Get the latest amount
 * @returns {Promise<Object>} - The API response with latest amount
 */
export { getLatestAmount };


